import { mapExchange, type OperationResult } from 'urql'
import { notifyError } from 'app/services/notify.client'
import { isSmsConsentRefusal } from 'app/lib/workflows/smsConsent'
import { AUTH_ERROR_MESSAGES } from './urqlAuthExchange'

declare module '@urql/core' {
  interface OperationContext {
    /** Set on an operation whose caller shows its own error message, so the global toast stays quiet. */
    suppressErrorToast?: boolean
  }
}

// Every GraphQL or network error becomes a toast unless the caller opts out.
// gqlQuery/gqlMutation never throw, and most callers do not read `error`, so a
// document that does not match the schema used to fail without any sign in the UI.
export function notifyOnError(result: OperationResult): void {
  const error = result.error
  if (!error || result.operation.context.suppressErrorToast) return
  // Not a failure to report: the caller answers this one by opening the consent modal.
  if (error.graphQLErrors.some((e) => isSmsConsentRefusal(e.message))) return
  // Expected permission block (e.g. Action Center value stats); real faults use a different code.
  if (error.graphQLErrors.some((e) => e.extensions?.code === `FORBIDDEN`)) return
  const graphQLMessages = error.graphQLErrors.map((e) => e.message)
  if (graphQLMessages.some((message) => AUTH_ERROR_MESSAGES.has(message))) return
  const message = graphQLMessages[0] ?? error.networkError?.message ?? error.message
  notifyError(message, String(result.operation.key))
}

export const errorNotifyExchange = mapExchange({ onResult: notifyOnError })
